import ReferAFriendPage from '@/app/modules/ReferAFriendPage';
import { getReferralAmount } from '@/app/services/cmsService';
import { getNewReferFriendPageFlag } from '@/app/utils/getServerFeatureFlag';
import { DynamicPageData, DynamicPageType } from '@/types/cms';
import { GetServerSidePropsContext } from 'next';
import { GetServerSidePropsResult } from 'next/types';
import React from 'react';
import { getDynamicPageData } from 'utils/getDynamicPageData';

import { DynamicPage } from 'components/CMS/DynamicPage';

interface AboutUsPagesProps extends DynamicPageData {
  showReferFriendPage: boolean;
  referralAmount?: string;
}

const AboutUs = ({ data, pageData, showReferFriendPage, referralAmount }: AboutUsPagesProps) => {
  return showReferFriendPage ? (
    <ReferAFriendPage pageData={pageData} referralAmount={referralAmount} />
  ) : (
    <DynamicPage data={data} pageData={pageData} />
  );
};

export async function getServerSideProps(
  context: GetServerSidePropsContext,
): Promise<GetServerSidePropsResult<AboutUsPagesProps>> {
  const { query } = context;
  const { slug } = query;

  const referFriendFeatureFlag = await getNewReferFriendPageFlag(context);
  let referralAmount;

  // 'rewards' is where the existing refer a friend page exists
  const showReferFriendPage = referFriendFeatureFlag && slug === 'rewards';

  if (showReferFriendPage) {
    referralAmount = await getReferralAmount();
  }

  const {
    modules = [],
    pageData,
    error,
  } = await getDynamicPageData(DynamicPageType.About_Us, context, slug as string);

  if (error) {
    return { notFound: true };
  }

  if (pageData?.redirect_url) {
    return {
      redirect: {
        destination: pageData.redirect_url,
        permanent: true,
      },
    };
  }

  return { props: { data: modules, pageData, showReferFriendPage, referralAmount } };
}

export default AboutUs;
